import React, { useRef } from 'react';
import styled from 'styled-components';
import CarousalCards from './partials/CarousalCards';
import {
  LandingLeftArrow,
  LandingRightArrow,
} from '../../../Common/SvgIcon/CommonSvgIcons';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '2560px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Wrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(100.52deg, #0c3f89 5.51%, #4aa373 94.49%);
  padding-bottom: 30px;
`;

const TitleText = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 28px;

  vertical-align: middle;
  color: #a1d823;
  @media only screen and ${device.tablet} {
    font-size: 20px;
    width: 160px;
    text-align: left;
  }
`;
const ArrowContainer = styled.div`
  display: flex;
  justify-content: end;
  @media only screen and ${device.desktop} {
    display: none;
  }
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;

const TitleWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  width: 1140px;
  justify-content: space-between;
  align-items: center;
  @media only screen and ${device.tablet} {
    max-width: 345px;
    margin-top: 30px;
  }
`;
const ImpactAcrossIndustries = () => {
  const containerRef = useRef(null);

  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount =
        window?.width > 768
          ? direction === 'left'
            ? -3000
            : 3000
          : direction === 'left'
          ? -280
          : 280;

      containerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  };
  return (
    <Wrapper>
      <TitleWrapper>
        <TitleText>Impact Across Industries</TitleText>
        <ArrowContainer>
          <ArrowButton
            onClick={() => {
              scroll('left');
            }}
          >
            {LandingLeftArrow}
          </ArrowButton>
          <ArrowButton
            onClick={() => {
              scroll('right');
            }}
          >
            {LandingRightArrow}{' '}
          </ArrowButton>
        </ArrowContainer>
      </TitleWrapper>
      <CarousalCards containerRef={containerRef} />
    </Wrapper>
  );
};
export default ImpactAcrossIndustries;
